import React from 'react'
import Responsive from 'react-responsive'

export const Desktop = ({ children }) => <Responsive minWidth={769} children={children} />
export const Mobile = ({ children }) => <Responsive maxWidth={768} children={children} />